import React from 'react';
import '../../TestView/styles.scss';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import strings from 'utils/strings';
import {Link} from 'react-router-dom';
import handBookPdf from 'assets/DysmateHåndbok_v1.1_compressed.pdf';
import {
	CHILD_SCRNG_NORMING_TEST_STEP_IDS,
	YOUTH_TEST_NORMING_STEP_IDS,
} from '../../../constants';
import {getPronoun} from 'utils/getPronouns';
import {formateTestName} from 'utils/formatTestName';

const TESTS_REQUIRED_TO_PASS = 3;

class Assessment extends React.Component {
	constructor(props) {
		super(props);
	}

	// eslint-disable-next-line complexity
	render() {
		const {testResult, completeName, firstName, testReportLang} =
			this.props;

		const hasSubtests =
			Array.isArray(testResult.subtests) &&
			testResult.subtests.length > 0;
		const language = hasSubtests
			? testResult.subtests[0].language
			: undefined;

		const subtestsLength = testResult.subtests.length;
		const allLowZscores = {};
		const localizedwriteuptextforNormalresults =
			testReportLang === 'nn'
				? strings._props.nn.localizedwriteuptextforNormalresults
				: strings.localizedwriteuptextforNormalresults;
		const localizedwriteuptextforOneOtherSubTest =
			testReportLang === 'nn'
				? strings._props.nn.localizedwriteuptextforOneOtherSubTest
				: strings.localizedwriteuptextforOneOtherSubTest;
		const localizedwriteuptextforTwoOtherSubTest =
			testReportLang === 'nn'
				? strings._props.nn.localizedwriteuptextforTwoOtherSubTest
				: strings.localizedwriteuptextforTwoOtherSubTest;
		const localizedwriteuptextforThreeORMoreOtherSubTest =
			testReportLang === 'nn'
				? strings._props.nn
						.localizedwriteuptextforThreeORMoreOtherSubTest
				: strings.localizedwriteuptextforThreeORMoreOtherSubTest;
		const localizedwriteuptextforIncompletedTest =
			testReportLang === 'nn'
				? strings._props.nn.localizedwriteuptextforIncompletedTest
				: strings.localizedwriteuptextforIncompletedTest;
		const localizedwriteuptextforLowScoreOfOrdiktatWithOneOtherSubTest =
			testReportLang === 'nn'
				? strings._props.nn
						.localizedwriteuptextforLowScoreOfOrdiktatWithOneOtherSubTest
				: strings.localizedwriteuptextforLowScoreOfOrdiktatWithOneOtherSubTest;
		const localizedwriteuptextforLowScoreOfBetyledeWithOneOtherSubTest =
			testReportLang === 'nn'
				? strings._props.nn
						.localizedwriteuptextforLowScoreOfBetyledeWithOneOtherSubTest
				: strings.localizedwriteuptextforLowScoreOfBetyledeWithOneOtherSubTest;
		const localizedwriteuptextforLowScoreInLeseprovenAndOrdforstaelse =
			testReportLang === 'nn'
				? strings._props.nn
						.localizedwriteuptextforLowScoreInLeseprovenAndOrdforstaelse
				: strings.localizedwriteuptextforLowScoreInLeseprovenAndOrdforstaelse;
		let zScoreLowCount = 0;
		let writeUpText;
		let clearlyBelowZScoreCount = 0;
		let significantlyBelowZScoreCount = 0;
		let withInZScoreCount = 0;
		let clearlyAboveZScoreCount = 0;
		let testType;
		let stringForLowScoreInTwoSubtest;
		let stringForOnRemainingOnes;
		let stringForTheSubtests;
		let stringForResutls;

		if (language === 'nn') {
			stringForOnRemainingOnes = strings.remainingOnesNn;
			stringForTheSubtests = strings.subtestsNn;
			stringForResutls = strings.resultsNn;
		} else {
			stringForOnRemainingOnes = strings.remainingOnes;
			stringForTheSubtests = strings.subtestsWord;
			stringForResutls = strings.resultsWord;
		}

		if (testResult.type === 'child-screening') {
			testType = CHILD_SCRNG_NORMING_TEST_STEP_IDS;
			stringForLowScoreInTwoSubtest = strings.formatString(
				localizedwriteuptextforLowScoreOfBetyledeWithOneOtherSubTest,
				`${getPronoun(testResult.testUser.gender, language)}`
			);
		} else {
			testType = YOUTH_TEST_NORMING_STEP_IDS;
			stringForLowScoreInTwoSubtest = strings.formatString(
				localizedwriteuptextforLowScoreOfOrdiktatWithOneOtherSubTest,
				`${firstName}`
			);
		}

		const findTestResult = testResult.subtests?.find((subtest) => {
			let subTestType;

			if (testType === CHILD_SCRNG_NORMING_TEST_STEP_IDS) {
				subTestType = CHILD_SCRNG_NORMING_TEST_STEP_IDS.BYTTELYDTESTEN;
			} else {
				subTestType = YOUTH_TEST_NORMING_STEP_IDS.ORDDIKTAT;
			}
			return subtest.id === subTestType;
		});

		testResult.subtests.forEach((subtest) => {
			if (subtest) {
				const {id, zScore} = subtest;
				if (zScore < -1) {
					zScoreLowCount++;
					allLowZscores[id] = zScore;
				}
				if (zScore > -2.0 && zScore < -1.01) {
					clearlyBelowZScoreCount++;
				} else if (zScore < -2.01) {
					significantlyBelowZScoreCount++;
				} else if (zScore > -1.0 && zScore < 1.0) {
					withInZScoreCount++;
				} else if (zScore > 1.01) {
					clearlyAboveZScoreCount++;
				}
			}
		});

		//maps test names with Zscores

		const allLowZscoresTestsWithNames = {};
		for (const [key, value] of Object.entries(testType)) {
			if (allLowZscores[value] !== undefined) {
				allLowZscoresTestsWithNames[key] = allLowZscores[value];
			}
		}
		const keys = Object.keys(allLowZscoresTestsWithNames);
		//if the the test is incomplete
		if (!hasSubtests) {
			// Bokmål / Nynorsk variants
			const line1_no = strings.formatString(
				strings.candidateNoSubtestsCompleted,
				completeName
			);
			const line2_no = strings.formatString(
				strings.candidateMustCompleteOneSubtest,
				completeName
			);

			const line1_nn = `${completeName} har ikkje gjennomført nokon deltestar.`;
			const line2_nn = `${completeName} må gjennomføre minst ein av deltestane for at vi skal kunne gje ei vurdering. Testen kan takast opp att frå «Mine testar».`;

			const pick = (bm, nn) => (testReportLang === 'nn' ? nn : bm);

			writeUpText = [
				pick(line1_no, line1_nn),
				pick(line2_no, line2_nn),
			].join('\n\n');
		} else if (testResult.completedAt === null) {
			writeUpText = strings.formatString(
				localizedwriteuptextforIncompletedTest,
				`${completeName}`
			);
		} else if (
			testResult.type !== 'child-screening' &&
			zScoreLowCount === 2 &&
			allLowZscoresTestsWithNames.hasOwnProperty('ORDFORSTÅELSE') &&
			allLowZscoresTestsWithNames.hasOwnProperty('LESEPRØVEN')
		) {
			writeUpText = strings.formatString(
				localizedwriteuptextforLowScoreInLeseprovenAndOrdforstaelse,
				`${completeName}`,
				clearlyBelowZScoreCount && !significantlyBelowZScoreCount
					? strings.formatString(
							strings.clearlyBelowOnNofSubtests,
							clearlyBelowZScoreCount,
							stringForTheSubtests
						)
					: '',
				significantlyBelowZScoreCount && !clearlyBelowZScoreCount
					? strings.formatString(
							strings.significantlyBelowOnNofSubtests,
							significantlyBelowZScoreCount,
							stringForTheSubtests
						)
					: '',
				clearlyBelowZScoreCount && significantlyBelowZScoreCount
					? strings.formatString(
							strings.clearlyAndSignificantlyBelowOnSubtests,
							clearlyBelowZScoreCount,
							stringForTheSubtests,
							significantlyBelowZScoreCount,
							stringForTheSubtests
						)
					: '',
				withInZScoreCount > 0 || clearlyAboveZScoreCount > 0
					? strings.formatString(
							strings.remainingSubtestsWithinOrAboveAverage,
							stringForOnRemainingOnes,
							stringForTheSubtests,
							firstName,
							stringForResutls
						)
					: '',
				`${getPronoun(testResult.testUser.gender, language)}`,
				<Link
					style={{color: 'blue'}}
					to={handBookPdf}
					target="_blank"
					rel="noopener noreferrer"
				>
					{strings.dysmateHandbook}
				</Link>
			);
		} else if (
			findTestResult?.zScore <= -1 ||
			zScoreLowCount >= TESTS_REQUIRED_TO_PASS
		) {
			//if the zscore are low in betelid test for child and ordiktat for youth and adult (only implemented for special case)
			switch (true) {
				//if only one tests have low zscores (betelid or ordiktat)
				case zScoreLowCount === 1:
					writeUpText = strings.formatString(
						localizedwriteuptextforNormalresults,
						`${completeName}`,
						withInZScoreCount && !clearlyAboveZScoreCount
							? strings.within
							: '',
						clearlyAboveZScoreCount && !withInZScoreCount
							? strings.clearlyover
							: '',
						withInZScoreCount && clearlyAboveZScoreCount
							? strings.withinAndClearlyOver
							: '',
						`${withInZScoreCount + clearlyAboveZScoreCount}`,
						`${getPronoun(testResult.testUser.gender, language)}`
					);
					break;
				//if only two tests have low zscores
				case zScoreLowCount === 2:
					writeUpText = strings.formatString(
						localizedwriteuptextforOneOtherSubTest,
						`${completeName}`,
						clearlyBelowZScoreCount &&
							!significantlyBelowZScoreCount
							? `klart under på ${clearlyBelowZScoreCount} av ${stringForTheSubtests}`
							: '',
						significantlyBelowZScoreCount &&
							!clearlyBelowZScoreCount
							? `betydelig under på ${significantlyBelowZScoreCount} av ${stringForTheSubtests}`
							: '',
						clearlyBelowZScoreCount && significantlyBelowZScoreCount
							? `klart under på ${clearlyBelowZScoreCount} av ${stringForTheSubtests} og betydelig under på ${significantlyBelowZScoreCount} av ${stringForTheSubtests} `
							: '',
						withInZScoreCount > 0 || clearlyAboveZScoreCount > 0
							? `På ${stringForOnRemainingOnes} ${stringForTheSubtests} oppnår ${firstName} ${stringForResutls} innenfor eller klart over gjennomsnittsområdet.`
							: '',
						stringForLowScoreInTwoSubtest,
						<Link
							style={{color: 'blue'}}
							to={handBookPdf}
							target="_blank"
							rel="noopener noreferrer"
						>
							Dysmate Håndbok
						</Link>
					);
					break;
				//if only three tests have low zscores
				case zScoreLowCount === 3:
					writeUpText = strings.formatString(
						localizedwriteuptextforTwoOtherSubTest,
						`${completeName}`,
						clearlyBelowZScoreCount &&
							!significantlyBelowZScoreCount
							? `klart under på ${clearlyBelowZScoreCount} av ${stringForTheSubtests}`
							: '',
						significantlyBelowZScoreCount &&
							!clearlyBelowZScoreCount
							? `betydelig under på ${significantlyBelowZScoreCount} av ${stringForTheSubtests}`
							: '',
						clearlyBelowZScoreCount && significantlyBelowZScoreCount
							? `klart under på ${clearlyBelowZScoreCount} av ${stringForTheSubtests} og betydelig under på ${significantlyBelowZScoreCount} av ${stringForTheSubtests} `
							: '',
						withInZScoreCount > 0 || clearlyAboveZScoreCount > 0
							? `På ${stringForOnRemainingOnes} ${stringForTheSubtests} oppnår ${firstName} ${stringForResutls} innenfor eller klart over gjennomsnittsområdet.`
							: '',
						`${getPronoun(testResult.testUser.gender, language)}`,
						`${formateTestName(keys[0])}`,
						`${formateTestName(keys[1])}`,
						`${formateTestName(keys[2])}`,
						`${firstName}`,
						<Link
							style={{color: 'blue'}}
							to={handBookPdf}
							target="_blank"
							rel="noopener noreferrer"
						>
							Dysmate Håndbok
						</Link>
					);
					break;
				//if more than three tests have low zscores
				case zScoreLowCount > 3:
					if (
						zScoreLowCount === 6 ||
						zScoreLowCount === 5 ||
						zScoreLowCount === 4
					) {
						const lastElement = keys[keys.length - 1];
						writeUpText = strings.formatString(
							localizedwriteuptextforThreeORMoreOtherSubTest,
							`${completeName}`,
							clearlyBelowZScoreCount &&
								!significantlyBelowZScoreCount
								? `klart under på ${clearlyBelowZScoreCount} av ${stringForTheSubtests}`
								: '',
							significantlyBelowZScoreCount &&
								!clearlyBelowZScoreCount
								? `betydelig under på ${significantlyBelowZScoreCount} av ${stringForTheSubtests}`
								: '',
							clearlyBelowZScoreCount &&
								significantlyBelowZScoreCount
								? `klart under på ${clearlyBelowZScoreCount} av ${stringForTheSubtests} og betydelig under på ${significantlyBelowZScoreCount} av ${stringForTheSubtests} `
								: '',
							withInZScoreCount > 0 || clearlyAboveZScoreCount > 0
								? `På ${stringForOnRemainingOnes} ${stringForTheSubtests} oppnår ${firstName} ${stringForResutls} innenfor eller klart over gjennomsnittsområdet.`
								: '',
							`${getPronoun(
								testResult.testUser.gender,
								language
							)}`,
							`${formateTestName(keys[0])}`,
							`${formateTestName(keys[1])}`,
							`${formateTestName(keys[2])}`,
							// eslint-disable-next-line no-nested-ternary
							keys[3]
								? keys[3] === lastElement
									? `og ${formateTestName(keys[3])}`
									: `, ${formateTestName(keys[3])}`
								: '',
							// eslint-disable-next-line no-nested-ternary
							keys[4]
								? keys[4] === lastElement
									? `og ${formateTestName(keys[4])}`
									: `, ${formateTestName(keys[4])}`
								: '',
							// eslint-disable-next-line no-nested-ternary
							keys[5]
								? keys[5] === lastElement
									? `og ${formateTestName(keys[5])}`
									: `, ${formateTestName(keys[5])}`
								: '',
							<Link
								style={{color: 'blue'}}
								to={handBookPdf}
								target="_blank"
								rel="noopener noreferrer"
							>
								Dysmate Håndbok
							</Link>
						);
					}
					break;
			}
		} else {
			//if the zscores are in normal range
			writeUpText = strings.formatString(
				localizedwriteuptextforNormalresults,
				`${completeName}`,
				withInZScoreCount && !clearlyAboveZScoreCount ? strings.within : '',
				clearlyAboveZScoreCount && !withInZScoreCount
					? strings.clearlyover
					: '',
				withInZScoreCount && clearlyAboveZScoreCount
					? strings.withinAndClearlyOver
					: '',
				`${withInZScoreCount + clearlyAboveZScoreCount}`,
				`${getPronoun(testResult.testUser.gender, language)}`
			);
		}
		return (
			<div className="sub-test__scores">
				<div className="width--half center">
					<h4 className="sub-test__heading big">
						{strings.assessment}
					</h4>
					<p>{writeUpText}</p>
				</div>
			</div>
		);
	}
}

Assessment.propTypes = {
	currentUser: PropTypes.shape({}),
};

const mapStateToProps = (state) => {
	const {currentUser} = state;

	return {
		currentUser,
	};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Assessment);
